import React, { useState } from "react";
import ToolTip from "../../common/ToolTip/ToolTip";
import { BtnVerifyEmailSave } from "./SettingButton";
import CorrectIcon from "../../resources/icons/correct-simple.svg";
import WarningIcon from "../../resources/icons/warning-simple.svg";
import InformationIcon from "../../resources/icons/information.svg";
import { CgAttachment } from "react-icons/cg";
import { RefreshCWIcon } from "../../components/icons";
import { useTranslation } from "react-i18next";
import { pageRootTestIds } from "../../testing/pageRootTestIds";

const SettingEmailAddress = ({
  isEmail,
  handleEmailChange,
  isEmailValid,
  isEmailSent,
  isVerified,
  handleTestEmail,
  handleVerifyEmail,
  isShowWarning,
  fetchOrgEmailDetails,
  isEmptyEmail,
}) => {
  const { t } = useTranslation();

  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = () => {
    fetchOrgEmailDetails();
    setIsRefreshing(true);
    setTimeout(() => {
      setIsRefreshing(false);
    }, 2000);
  };

  return (
    <div className="w-full p-3" id={pageRootTestIds.settingEmailAddress}>
      <div className="text-xl font-semibold text-gray-900">
        <p>{t("settings:add_your_email")}</p>
      </div>
      <div className="my-4 w-[90%] lg:w-[50%]">
        <div className="flex">
          <label
            className="flex mb-2 text-sm font-medium text-gray-900"
            htmlFor="org_from_mail"
          >
            {t("settings:email_address")}
          </label>
        </div>
        <div className="flex gap-4">
          <input
            type="email"
            id="org_from_mail"
            value={isEmail}
            onChange={handleEmailChange}
            className={`bg-gray-50 border ${
              isEmailValid ? "border-gray-300" : "border-red-500"
            } text-gray-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
            placeholder="e.g. Ooru@example.com"
            disabled={isVerified}
          />
          {isEmailSent && isVerified && !isEmptyEmail && (
            <ToolTip
              component={
                <img src={CorrectIcon} height={42} width={42} alt="" />
              }
              message={t("settings:email_is_verified")}
              tooltipPosition={"top-[-2.8rem]"}
              bgColor={"#12B76A"}
              tooltipWidth={"max-w-[300px]"}
            />
          )}
          {!isVerified && isShowWarning && !isEmptyEmail && (
            <ToolTip
              component={
                <img src={WarningIcon} height={42} width={42} alt="" />
              }
              message={t("settings:email_verification_failed")}
              tooltipPosition={"top-[-2.8rem]"}
              bgColor={"#bb2124"}
              tooltipWidth={"max-w-[300px]"}
            />
          )}
          {!isVerified && !isShowWarning && !isEmptyEmail && (
            <ToolTip
              component={
                <img src={WarningIcon} height={42} width={42} alt="" />
              }
              message={t("settings:email_verification_pending")}
              tooltipPosition={"top-[-2.8rem]"}
              bgColor={"#E0781A"}
              tooltipWidth={"max-w-[300px]"}
            />
          )}
        </div>
        {isEmail && !isEmailValid && (
          <div className="text-xs text-red-500 mt-[0.1rem]">
            {t("settings:enter_valid_email_address")}
          </div>
        )}
      </div>
      <div className="flex items-center mb-4">
        <img src={InformationIcon} height={16} width={16} alt="" />
        <div className="text-xs text-black ml-1">
          {isVerified
            ? t("settings:test_email_description")
            : t("settings:email_notification_holders")}
        </div>
      </div>
      <div className="flex gap-5">
        <div>
          {isVerified ? (
            <BtnVerifyEmailSave
              Display_Icon={CgAttachment}
              TriggerBtn={handleTestEmail}
              DisplayText={t("settings:test_email")}
              type="submit"
              enabledButton={isEmail && isEmailValid}
              disabledButton={!isEmail && !isEmailValid}
            />
          ) : isEmptyEmail ? (
            <BtnVerifyEmailSave
              Display_Icon={CgAttachment}
              TriggerBtn={handleVerifyEmail}
              DisplayText={t("settings:verify_email")}
              type="submit"
              enabledButton={isEmail && isEmailValid && !isEmailSent}
              disabledButton={!isEmail || !isEmailValid || isEmailSent}
            />
          ) : (
            <BtnVerifyEmailSave
              Display_Icon={CgAttachment}
              TriggerBtn={handleVerifyEmail}
              DisplayText={t("settings:resend_verification_email")}
              type="submit"
              enabledButton={isEmail && isEmailValid && !isEmailSent}
              disabledButton={!isEmail || !isEmailValid || isEmailSent}
            />
          )}
        </div>

        {!isShowWarning && !isVerified && !isEmptyEmail && (
          <ToolTip
            component={
              <button
                id="setting-email-address-refresh"
                className="focus:outline-none"
                onClick={handleRefresh}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleRefresh();
                  }
                }}
                aria-label={t("settings:refresh_update_email_status")}
              >
                <RefreshCWIcon
                  size={30}
                  className={`inline-flex ${isRefreshing ? "animate-spin" : ""}`}
                  aria-hidden
                />
              </button>
            }
            message={t("settings:refresh_to_update")}
            tooltipPosition={"top-[-2.8rem]"}
            bgColor={"#E0781A"}
            tooltipWidth={"max-w-[300px]"}
          />
        )}
      </div>
    </div>
  );
};

export default SettingEmailAddress;
